import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "exam-goal-return__label" }

import { computed, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import api from '../../../api/v2/api'
import { examGoalContext, rememberExamGoal, goalPath } from '../../utils/exam_goal_context'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamGoalReturnButton',
  props: {
    examId: {},
    color: { default: 'primary' },
    variant: { default: 'flat' }
  },
  setup(__props: any) {

const props = __props
const router = useRouter()
const context = computed(() => examGoalContext(props.examId))
const fetchedName = ref<string | undefined>(undefined)
const goalName = computed(() => context.value?.goalName || fetchedName.value)

onMounted(async () => {
  const ctx = context.value
  if (!ctx || ctx.goalName) return
  try {
    const userGoal = await api.userGoal.show(ctx.userGoalId)
    fetchedName.value = userGoal.goal?.name
    if (fetchedName.value) rememberExamGoal(props.examId, ctx.userGoalId, fetchedName.value)
  } catch { /* 名前が取れなくても「ゴールに戻る」は出す */ }
})

function goBack() {
  if (context.value) router.push(goalPath(context.value))
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" ゴールから開いたテストだけ出す「ゴール（ゴール名）に戻る」 "),
    (context.value)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          class: "exam-goal-return",
          color: __props.color,
          variant: __props.variant,
          size: "small",
          onClick: goBack
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { start: "" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-flag-variant-outline", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createElementVNode("span", _hoisted_1, "ゴール" + _toDisplayString(goalName.value ? `（${goalName.value}）` : '') + "に戻る", 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["color", "variant"]))
      : _createCommentVNode("v-if", true)
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

})